export default __webpack_public_path__ + "static/media/order-placed-clip.0358f308.mp4";